<template>
  <li class="atomic group">
    <fieldset v-if="number === '2'">
      <legend>
        <span :id="`party${number}AddressSame-label`" class="label">Is person 2’s residential address the same as person
          1's?</span>
        <abbr class="required" title="(required)">*</abbr>
      </legend>

      <ul class="choices compact">
        <li>
          <input class="" required="true" checked type="radio" :id="`party${number}AddressSame.yes`" value="true"
            :name="`Party ${number} Address Same`" v-model="addressSame" @change="copyAddress(true)"/>
          <label :for="`party${number}AddressSame.yes`">Yes</label>
        </li>
        <li>
          <input class="" required="true" type="radio" :id="`party${number}AddressSame.no`" value="false"
            :name="`Party ${number} Address Same`" v-model="addressSame" @change="copyAddress(false)"/>
          <label :for="`party${number}AddressSame.no`">No</label>
        </li>
      </ul>
    </fieldset>
    <section v-if='addressSame === "false"'>
      <fieldset>
        <legend>
          <span :id="`party${number}ResidentialAddressAustralia-label`" class="label">Is person {{ number }}’s
            residential address in Australia?</span>
          <abbr class="required" title="(required)">*</abbr>
        </legend>

        <ul class="choices compact">
          <li>
            <input class="" required="true" checked type="radio" :id="`party${number}ResidentialAddressAustralia.yes`"
              value="true" :name="`Party ${number} Residential Address Australia`"
              v-model="residentialAddressAustralia" />
            <label :for="`party${number}ResidentialAddressAustralia.yes`">Yes</label>
          </li>
          <li>
            <input class="" required="true" type="radio" :id="`party${number}ResidentialAddressAustralia.no`"
              value="false" :name="`Party ${number} Residential Address Australia`"
              v-model="residentialAddressAustralia" />
            <label :for="`party${number}ResidentialAddressAustralia.no`">No</label>
          </li>
        </ul>
      </fieldset>
      <AutoCompleteAddress v-model="addressDetails" @input="updateForm" :prefix="`party${number}`"
        :residentialAddressAustralia="residentialAddressAustralia" />
    </section>
  </li>
</template>

<script>
import AutoCompleteAddress from '../AutoCompleteAddress.vue';

export default {
  methods: {
    updateForm(childAddressDetails) {
      this.addressDetails = {...this.addressDetails, ...childAddressDetails}
    },
    copyAddress(isSame) {
      this.$emit("copyAddress", isSame);
    },
  },
  components: {
    AutoCompleteAddress
  },
  data() {
    return {
      residentialAddressAustralia: "true",
      addressSame: "false",
    }
  },
  props: {
    number: String,
    value: Object,
  },
  computed: {
    addressDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
